// Zwei kleine Helfer fuers Scrollen:
//   1. ein duenner Fortschrittsbalken unter der Kopfzeile
//   2. ein "Nach oben"-Knopf, der erst nach einer Weile erscheint
//
// Beides ohne Zusatzprogramme und ohne fremde Server. Wer in den
// Systemeinstellungen "Bewegung reduzieren" gewaehlt hat, bekommt den
// Balken ohne Uebergang und den Knopf ohne Einblenden.
import React, { useEffect, useState } from "react";

export function ScrollBalken() {
  const [anteil, setAnteil] = useState(0);

  useEffect(() => {
    const rechne = () => {
      const hoehe = document.documentElement.scrollHeight - window.innerHeight;
      setAnteil(hoehe > 0 ? Math.min(100, (window.scrollY / hoehe) * 100) : 0);
    };
    rechne();
    window.addEventListener("scroll", rechne, { passive: true });
    window.addEventListener("resize", rechne);
    return () => {
      window.removeEventListener("scroll", rechne);
      window.removeEventListener("resize", rechne);
    };
  }, []);

  return (
    <div className="scroll-balken" aria-hidden="true">
      <span style={{ width: `${anteil}%` }} />
    </div>
  );
}

export function NachOben() {
  const [zeigen, setZeigen] = useState(false);

  useEffect(() => {
    // Erst ab zwei Bildschirmhoehen einblenden - vorher ist der Weg
    // nach oben ohnehin kurz.
    const pruefe = () => setZeigen(window.scrollY > window.innerHeight * 2);
    pruefe();
    window.addEventListener("scroll", pruefe, { passive: true });
    return () => window.removeEventListener("scroll", pruefe);
  }, []);

  return (
    <button
      type="button"
      className={`nach-oben ${zeigen ? "sichtbar" : ""}`}
      aria-label="Nach oben"
      tabIndex={zeigen ? 0 : -1}
      onClick={() => {
        const sanft = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollTo({ top: 0, behavior: sanft ? "auto" : "smooth" });
      }}
    >
      <i className="fas fa-chevron-up" aria-hidden="true"></i>
    </button>
  );
}
